import React from 'react';

class Extractor extends React.Component {
  onDragStart = (event) => {
    event.dataTransfer.effectAllowed = 'move';
    event.dataTransfer.setData('text', JSON.stringify(this.props));
    return true;
  };

  componentDidMount = () => {
    setInterval(() => {
      console.log('Auto collection', this.props.data);
      this.props.callback(this.props.data);
    }, 5000);
  };

  render() {
    return (
      <div
        className="extractor"
        draggable="true"
        onDragStart={this.onDragStart}
      >
        {this.props.data.name}
        <br />
        {this.props.data.totalResources}
      </div>
    );
  }
}

export { Extractor };
